import "./loader.css";

export function Loader() {
  return (
    <div class="loader">
      <div class="wrapper">
        <div class="circle"></div>
        <div class="line-1"></div>
        <div class="line-2"></div>
        <div class="line-3"></div>
        <div class="line-4"></div>
        <div class="line-5"></div>
        <div class="line-6"></div>
      </div>
    </div>
  );
}
export function LoaderCircle() {
  return (
    <div class="loadingio-spinner-spinner-977el9wwy2v">
      <div class="ldio-4j5ay0xf86g   ">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
